<template>
  <div>
    <ca-row v-if="hasFilters">
      <template v-if="shouldShowAllocationOrJobDescriptionFields">
        <ca-col v-if="options.showStockingSelect" size="6">
          <stocking-select
            v-model="reportFilters.stocking"
            show-all
            required />
        </ca-col>
        <ca-col v-if="options.showJobDescriptionSelect" size="6">
          <job-description-select
            v-model="reportFilters.jobDescription"
            show-all
            required />
        </ca-col>
      </template>
      <template v-if="shouldShowPartnerEmployeeSelect">
        <ca-col v-if="options.showPartnerEmployeeSelect" size="6">
          <collaborator-select
            v-model="reportFilters.worker"
            show-all
            required
            :collaborator-find-type="collaboratorFindTypes.EMPLOYEE_PARTNER"
            @change="onCollaboratorChange" />
        </ca-col>
      </template>
      <template v-if="shouldShowWorkerOrEventFields">
        <ca-col v-if="options.showWorkerSelect" size="6">
          <collaborator-select
            v-model="reportFilters.worker"
            show-all
            required
            @change="onCollaboratorChange" />
        </ca-col>
        <ca-col v-if="options.showEventSelect" size="6">
          <event-select
            v-model="reportFilters.event"
            show-all
            on-fetch-error-message="O relatório não foi gerado pois houve um problema na conexão,
              tente novamente."
            required />
        </ca-col>
      </template>
      <template v-if="shouldShowDateFields">
        <ca-col v-if="options.showDateMonthPeriod" size="4">
          <ca-field label="Período">
            <ca-monthpicker
              v-model="reportFilters.dateMonthPeriod"
              month-as-number />
          </ca-field>
        </ca-col>
        <ca-col v-if="options.showDateYearPeriod" size="4">
          <ca-field label="Ano">
            <ca-input
              v-model="reportFilters.dateYearPeriod"
              mask-pattern="9999"
              type="number"
              required />
          </ca-field>
        </ca-col>
        <ca-col v-if="options.showDatePeriod" size="4">
          <ca-field label="Data de Referência">
            <ca-date-input v-model="reportFilters.datePeriod" />
          </ca-field>
        </ca-col>
        <ca-col v-if="options.showInternSelect" size="6">
          <collaborator-select
            v-model="selectedCollaborator"
            label="Estagiário"
            only-interns
            required
            @change="onCollaboratorChange" />
        </ca-col>
      </template>
      <template v-if="options.showDescription">
        <ca-col>
          <ca-field label="Descrição">
            <ca-textarea v-model="reportFilters.description" />
          </ca-field>
        </ca-col>
      </template>
      <template v-if="shouldShowGroupFields">
        <ca-col>
          <ca-row-divider margin="small" />
          <ca-row>
            <ca-col v-if="options.showGroupBy" size="4">
              <ca-field label="Agrupar Por">
                <ca-radio-group
                  v-model="reportFilters.groupBy"
                  :options="groupByOptions"
                  direction="horizontal" />
              </ca-field>
            </ca-col>
            <ca-col v-if="options.showOrderBy" size="4">
              <ca-field label="Ordenar Por">
                <ca-radio-group
                  v-model="reportFilters.orderBy"
                  :options="orderByOptions"
                  direction="horizontal" />
              </ca-field>
            </ca-col>
          </ca-row>
        </ca-col>
      </template>
    </ca-row>
    <ca-row v-else>
      <ca-col>
        <ca-heading
          text="Nenhum filtro necessário para gerar esse relatório."
          size="extra-small" />
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { COLLABORATORS_FIND_TYPE } from 'accountant/worker/constants';
import { mapReportFilters } from './reportCenterModalFiltersService';
import { GROUP_BY_OPTIONS, ORDER_BY_OPTIONS } from './constants';

export default {
  name: 'ReportCenterModalFilters',
  props: {
    filters: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => {
        return {
          showStockingSelect: false,
          showJobDescriptionSelect: false,
          showWorkerSelect: false,
          showPartnerEmployeeSelect: false,
          showInternSelect: false,
          showDateMonthPeriod: false,
          showDateYearPeriod: false,
          showDescription: false,
          showDatePeriod: false,
          showEventSelect: false,
          showGroupBy: false,
          showOrderBy: false,
        };
      },
    },
  },
  data() {
    return {
      reportFilters: this.filters,
      selectedCollaborator: null,
      isInternFilterModal: false,
    };
  },
  computed: {
    collaboratorFindTypes() {
      return COLLABORATORS_FIND_TYPE;
    },
    groupByOptions() {
      return GROUP_BY_OPTIONS;
    },
    orderByOptions() {
      return ORDER_BY_OPTIONS;
    },
    hasFilters() {
      return Object.keys(this.options)
        .filter(option => this.options[option] === true).length > 0;
    },
    shouldShowPartnerEmployeeSelect() {
      return this.options.showPartnerEmployeeSelect;
    },
    shouldShowAllocationOrJobDescriptionFields() {
      return this.options.showStockingSelect || this.options.showJobDescriptionSelect;
    },
    shouldShowWorkerOrEventFields() {
      return this.options.showWorkerSelect || this.options.showEventSelect;
    },
    shouldShowDateFields() {
      return this.options.showDateMonthPeriod
        || this.options.showDateYearPeriod
        || this.options.showDatePeriod;
    },
    shouldShowGroupFields() {
      return this.options.showGroupBy || this.options.showOrderBy;
    },
  },
  watch: {
    reportFilters: {
      deep: true,
      immediate: true,
      handler() {
        this.handleUpdate();
      },
    },
  },
  mounted() {
    if (this.options.showInternSelect) {
      this.$emit('is-intern', true);
    }
  },
  methods: {
    handleUpdate() {
      this.$emit('update', mapReportFilters(this.reportFilters, this.options));
    },
    onCollaboratorChange(collaborator) {
      const collaboratorMapped = {
        idFuncionario: collaborator.id,
        collaboratorType: collaborator.type,
      };
      this.reportFilters = { ...this.reportFilters, ...collaboratorMapped };
      this.$emit('intern-id', collaborator.id);
      this.handleUpdate();
    },
  },
};
</script>
